export const DELETION_GRACE_PERIOD_DAYS = 30;

export const DELETION_SCHEDULED_HEADER = "X-Deletion-Scheduled";

export const DELETE_RIGHT_NOW_PHRASE = "deleterightnow";

export enum AccountDeletionErrorReason {
  OUTCOME_CHANGED = "account_deletion_errors.outcome_changed",
  IMPERSONATION_BLOCKED = "account_deletion_errors.impersonation_blocked",
  DELETION_DUE = "account_deletion_errors.deletion_due",
  DELETION_SCHEDULED = "account_deletion_errors.deletion_scheduled",
  DELETION_CHANGED = "account_deletion_errors.deletion_changed",
}

export enum AccountDeletionOutcome {
  RESET = "reset",
  TOMBSTONE = "tombstone",
  ORGANIZATION = "organization",
  LAST_ADMIN = "last_admin",
}

export interface AccountDeletionRequestInterface {
  outcome: AccountDeletionOutcome;
}

export interface AccountDeletionPreviewInterface {
  outcome: AccountDeletionOutcome;
}

export interface ScheduledDeletionInterface {
  deleteAt: string;
}
